//#region Import
import React from 'react';
/* React Router */
import { NavLink, withRouter } from 'react-router-dom';

/* Json */
import { safeDeepGet } from 'iotera-base/json'
import { isFunction } from 'iotera-base/object';

/* Icon */
import AppsIcon from '@material-ui/icons/Apps';
import LoraIcon from '@material-ui/icons/WifiTethering';

/* Logo */
import Logo from '../../lib/components/iconColor/logo.png'
import LogoOnly from '../../lib/components/iconColor/logo-only.png'

/* Scrollbar */
import ScrollArea from '../scrollbar';

/* Routes */
import { S_TENANT, S_APPS, S_GATES, S, isTenant } from '../../routes/routes';

/* Style */
import './style.scss';

/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/ViewList';
import MiniIcon from '@material-ui/icons/MoreVert';
import { CustomNavStyle } from '../../lib/preferences/nav-style';
import { NavigationDrawerWithTooltip } from '../../lib/components/navigation';

/* React Strap */
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

/* Screenfull */
import screenfull from 'screenfull';

/* Icon */
import { MdCropFree as IconFullScreen, MdPowerSettingsNew as IconLogout } from 'react-icons/md';

import Person from '@material-ui/icons/Person';
import IoteraClass from '../../lib/components/react/react-class';
// #endregion

const TenantNavHead = (props) => {
    if (props.open) {
        return (
            <header >
                <img src={Logo} alt="Logo" width='auto' height={36} />
            </header>
        );
    } else {
        return (
            <header >
                <img src={LogoOnly} alt="Logo" width='auto' height={36} />
            </header>
        );
    }
}

class MiniDrawer extends IoteraClass {
    constructor(props) {
        super(props);
        const _isTenant = isTenant(props);

        this.state = {
            _isTenant
        };
        this.handleLogout = this.handleLogout.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick = (location) => {
        if (window.innerWidth <= 5000) {
            if (isFunction(this.props.hideNav)) {
                this.props.hideNav();
            }
        }

        if (location !== S) {
            this.props.history.push(location)
        }

    }

    handleDrawerOpen = () => {
        this.setState({ open: true });
        if (isFunction(this.props.toggleNav)) {
            this.props.toggleNav();
        }
    };

    handleDrawerClose = () => {
        this.setState({ open: false });
        if (isFunction(this.props.toggleNav)) {
            this.props.toggleNav();
        }

    };

    handleLogout = (e) => {
        const logout = safeDeepGet(this, ['props', 'logout']);
        if (isFunction(logout)) {
            logout();
        }
    }

    render() {
        const { classes, theme } = this.props;

        let location = safeDeepGet(this, ['props', 'location', 'pathname'], '');

        let tenantNavs = [
            { label: "Aplikasi", icon: AppsIcon, path: S_TENANT + S_APPS + S + 'list', key: 1 },
            // { label: "Lora Gateway", icon: LoraIcon, path: S_TENANT + S_GATES + S + 'list', key: 2 },
        ];

        let navs = '';
        // Dashboard Management
        navs =
            <NavigationDrawerWithTooltip
                handleClick={this.handleClick} location={location} classes={classes} open={this.props.open} navList={tenantNavs}
            />
        let drawerVariant = window.innerWidth <= 5000 ? null : 'permanent'

        return (
            <div className={classes.root}>
                <CssBaseline />
                <AppBar
                    position="static"
                    className={classNames(classes.appBar, {
                        [classes.appBarShift]: this.props.open,
                    })}
                >
                    <Toolbar disableGutters={!this.props.open}>


                        {window.innerWidth <= 5000 ?
                            this.props.open ?
                                <Tooltip TransitionComponent={Zoom} title="Mini Menu" enterDelay={500}>
                                    <IconButton
                                        color="inherit"
                                        onClick={this.handleDrawerClose}
                                        className={classNames(classes.menuButton, {
                                            [classes.hide]: !this.props.open,
                                        })}>
                                        {theme.direction === 'rtl' ? <MiniIcon /> : <MiniIcon />}
                                    </IconButton>
                                </Tooltip>
                                :
                                <Tooltip TransitionComponent={Zoom} title="Menu" enterDelay={500}>
                                    <IconButton
                                        color="inherit"
                                        aria-label="Open drawer"
                                        onClick={this.handleDrawerOpen}
                                        className={classNames(classes.menuButton, {
                                            [classes.hide]: this.props.open,
                                        })}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                </Tooltip>
                            :
                            <div style={{ marginRight: 12 }} />
                        }

                        <Typography variant="h6" color="inherit" style={{ flexGrow: 1, textTransform: 'capitalize' }}>
                            Iotera Platform
                        </Typography>

                        <div >
                            <Tooltip TransitionComponent={Zoom} title="Full Screen" enterDelay={500}>
                                {screenfull.enabled ?
                                    <IconButton color="inherit" aria-label="Menu" onClick={event => screenfull.toggle()}  >
                                        <IconFullScreen size="24" />
                                    </IconButton>
                                    :
                                    <IconButton color="inherit" aria-label="Menu"  >
                                        <IconFullScreen size="24" />
                                    </IconButton>
                                }
                            </Tooltip>
                        </div>

                        <div>
                            <Tooltip TransitionComponent={Zoom} title="Akses" enterDelay={500}>
                                <UncontrolledDropdown>
                                    <DropdownToggle tag="div">
                                        <IconButton color="inherit" aria-label="Menu" >
                                            <Person size="24" />
                                        </IconButton>
                                    </DropdownToggle>
                                    <DropdownMenu right style={{ minWidth: '12rem' }}>
                                        <DropdownItem onClick={this.handleLogout} style={{ marginLeft: 7 }}>
                                            <IconLogout size="16" />
                                            &emsp;Logout</DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </Tooltip>
                        </div>
                    </Toolbar>
                </AppBar >
                <SwipeableDrawer
                    variant={drawerVariant}
                    anchor="left"
                    onClose={this.handleDrawerClose}
                    onOpen={this.handleDrawerOpen}
                    className={classNames(classes.drawer, {
                        [classes.drawerOpen]: this.props.open,
                        [classes.drawerClose]: !this.props.open,
                    })}
                    classes={{
                        paper: classNames({
                            [classes.drawerOpen]: this.props.open,
                            [classes.drawerClose]: !this.props.open,
                        }),
                    }}

                    swipeAreaWidth={0}
                    open={this.props.open}
                >
                    <Tooltip TransitionComponent={Zoom} title='List Aplikasi' placement='bottom-start' enterDelay={500} >
                        <NavLink activeClassName="active" to={S_TENANT}>
                            <div className={classes.toolbar}>
                                <TenantNavHead open={this.props.open} />
                            </div>
                        </NavLink>
                    </Tooltip>
                    <Divider />
                    <ScrollArea horizontal={false} verticalScrollbarStyle={{ width: '4px', marginLeft: '10px' }}>
                        <ul className="list-unstyled">
                            {this.props.open ? <li><div className={classes.navListTitle}>Platform</div></li> : null}
                            {navs}
                        </ul>
                    </ScrollArea>
                </SwipeableDrawer>
            </div >
        );
    }
}

MiniDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(CustomNavStyle, { withTheme: true })(withRouter(MiniDrawer));